import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

interface Vars {
    groupId: string;
    position: number;
}

export function useDeleteSecurityGroupRuleMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ groupId, position }: Vars) =>
            Endpoints.v1.Firewalls.SecurityGroupRules.deleteRule(groupId, position),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.security-group-rules', vars.groupId],
            });
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.security-groups.infinite'],
            });
            notifications.show({
                title: t('securityGroup.ruleDeletedTitle'),
                message: t('securityGroup.ruleDeletedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('securityGroup.ruleDeleteFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
